export const APP_NAME = 'Relaycode';
export const COMMAND_NAME = 'relay';

export const CONFIG_FILE_NAME_JSON = 'relay.config.json';
export const CONFIG_FILE_NAMES = [CONFIG_FILE_NAME_JSON];
export const STATE_DIRECTORY_NAME = '.relay';
export const GITIGNORE_FILE_NAME = '.gitignore';
export const FALLBACKS_DIR = 'fallbacks';
export const WINDOWS_DIR = 'windows';

export const WINDOWS_CLIPBOARD_EXE_NAME = 'clipboard_x86_64.exe';

export const GITIGNORE_COMMENT = '# relay state';
